/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar13 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar13", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.105,4,24,4z M12.537,21.543 h-1.792v-5.43h-0.093l-1.699,1.147v-1.543l1.792-1.221h1.792V21.543z M18.127,21.734c-1.646,0-2.754-0.898-2.817-2.28h1.709 c0.024,0.537,0.459,0.869,1.138,0.869c0.635,0,1.074-0.361,1.074-0.889c0-0.542-0.415-0.874-1.099-0.874h-0.864v-1.235h0.864 c0.601,0,0.996-0.337,0.996-0.85s-0.386-0.83-1.011-0.83c-0.615,0-1.03,0.366-1.05,0.918h-1.626 c0.024-1.377,1.079-2.256,2.715-2.256c1.562,0,2.637,0.786,2.637,1.924c0,0.811-0.542,1.45-1.333,1.597v0.093 c0.972,0.103,1.592,0.742,1.592,1.65C21.052,20.845,19.851,21.734,18.127,21.734z M24,10H6V6h18V10z" />
      </svg>
    );
  }
}

IconCalendar13.defaultProps = {
  className: null
};

IconCalendar13.propTypes = {
  className: PropTypes.string
};

export default IconCalendar13;
